import {Type} from 'class-transformer';
import {serializeType} from "./common";

import {SalesTaxRate, TradingPartnerInfo} from './trading-partner';
import {OrgAchDetail} from "./org-ach-detail";
import {OrgCreditCard} from "./org-credit-card";
import {OrgContact} from "./org-contact";
import {OrgAddress} from './org-address';
import {AchBusinessType} from "@app/shared/enums/ach-business-type.enum";
import {AchCustomer} from "@app/shared/classes/ach-customer";
import {CyberplanConfigType} from "@app/shared/enums/cyberplan-config-type.enum";


export class OrgSalesTax {
  id: number;
  version: number;
  shipToId: number;
  vendorId: number;
  salesTaxRateId: number;
  addrName: string;
  @Type(serializeType(SalesTaxRate)) salesTaxRateDetail?: SalesTaxRate;
  @Type(serializeType(TradingPartnerInfo)) vendorDetail?: TradingPartnerInfo;
}

export class AchAddress {
  address1: string;
  address2: string;
  city: string;
  stateProvinceRegion: string;
  postalCode: string;
  country: string;
}

export class Passport {
  number?: string;
  country?: string;
}

export enum BeneficialOwnerStatus {
  Verified = "verified", Pending = "pending", Document = "document", Incomplete = "incomplete",
  DocumentInReview= "document-in-review"
}

export class OrgBeneficialOwner {
  id?: number;
  version?: number;
  dwollaId?: string;
  firstName?: string;
  lastName?: string;
  ssn?: string;
  dateOfBirth?: string;
  status?: string;
  ownerOrgId?: number;
  address?: AchAddress;
  passport?: Passport;
}

export class OrgController {
  id?: number;
  version?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  title?: string;
  ssn?: string;
  dateOfBirth?: string;
  orgId?: number;
  address?: AchAddress;
  passport?: Passport;
}


export class OrgUnit {
  id: number;
  version: number;
  active: boolean;
  taxNumber: string;
  ein: string;
  isSsn: boolean;
  cageCode: string;
  dunsNumber: string;
  businessName: string;
  dbaName: string;
  website: string;
  sameAsDba: boolean;

  inherited: boolean;
  overridable: boolean;
  billingContactSameAsMain: boolean;
  override: boolean;
  industryType: string;
  businessClassification: string;
  industryClassification: string;
  businessType: AchBusinessType;
  goLiveDate: string;
  fiscalYearStartMonthId: string;

  cyberplanConfigType: CyberplanConfigType;

  realmId: number;
  parentId: number;
  realmName: string;
  displayAccountNumber: string;
  @Type(serializeType(Date)) displayModifiedOn: Date;
  parentOrgName: string;
  @Type(serializeType(AchCustomer)) achCustomerDetails: AchCustomer;
  @Type(serializeType(OrgController)) orgController: OrgController;
  @Type(serializeType(OrgUnit)) children: OrgUnit[];
  @Type(serializeType(OrgAddress)) orgAddresses: OrgAddress[];
  @Type(serializeType(OrgContact)) orgContacts: OrgContact[];
  @Type(serializeType(OrgAchDetail)) orgAchDetails: OrgAchDetail[];
  @Type(serializeType(OrgCreditCard)) orgCreditCards: OrgCreditCard[];
  @Type(serializeType(OrgSalesTax)) orgSalesTaxes: OrgSalesTax[];
  @Type(serializeType(OrgBeneficialOwner)) orgBeneficialOwners: OrgBeneficialOwner[];

  goLiveDateEnabled?: boolean = true;
  fiscalYearStartMonthEnabled?: boolean = true;

  constructor() {
    this.inherited = true;
  }
}

